import React from 'react';
export function TestimonialsSection() {
  return <section className="bg-navy px-5 py-20" data-id="element-258">
      <div className="mx-auto max-w-[900px]" data-id="element-259">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-260">
          // REAL RESULTS FROM REAL PROFESSIONALS
        </p>
        <h2 className="mb-4 text-center text-[clamp(26px,4vw,42px)] font-black leading-[1.2] text-offwhite" data-id="element-261">
          4,200+ People Have{' '}
          <span className="text-neon" data-id="element-262">Deleted Their Brain Fog.</span>
        </h2>
        <p className="mx-auto mb-[50px] max-w-[650px] text-center text-[17px] leading-[1.7] text-coolgray" data-id="element-263">
          Here's what high-performers across the USA are saying after applying
          the 15-minute protocol.
        </p>

        <div className="mb-10 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-264">
          <div className="relative rounded-2xl border border-neon/10 bg-slate p-7 transition-all duration-300 hover:-translate-y-1 hover:border-neon/30" data-id="element-265">
            <div className="mb-2 text-[13px] text-gold" data-id="element-266">★★★★★</div>
            <div className="mb-3 font-serif text-[48px] leading-[0.8] text-neon/30" data-id="element-267">
              "
            </div>
            <p className="mb-5 text-[15px] italic leading-[1.7] text-offwhite" data-id="element-268">
              "I was skeptical. I've tried every productivity hack in the book.
              But the caffeine delay protocol alone changed my entire afternoon.
              I finish my tasks 2 hours earlier now."
            </p>
            <div className="mb-4 rounded-lg border border-neon/20 bg-neon/10 px-3.5 py-2.5 font-mono text-[13px] font-bold text-neon" data-id="element-269">
              ⚡ Result: +2hrs of peak focus daily
            </div>
            <div className="flex items-center gap-3" data-id="element-270">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-neon/20 bg-card text-[22px]" data-id="element-271">
                👨
              </div>
              <div data-id="element-272">
                <div className="text-[14px] font-bold text-offwhite" data-id="element-273">
                  Mark S.
                </div>
                <div className="font-mono text-[12px] text-coolgray" data-id="element-274">
                  Senior Engineer — Austin, TX
                </div>
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl border border-neon/30 bg-gradient-to-br from-slate to-[#0D2040] p-7 transition-all duration-300 hover:-translate-y-1" data-id="element-275">
            <div className="mb-2 text-[13px] text-gold" data-id="element-276">★★★★★</div>
            <div className="mb-3 font-serif text-[48px] leading-[0.8] text-neon/30" data-id="element-277">
              "
            </div>
            <p className="mb-5 text-[15px] italic leading-[1.7] text-offwhite" data-id="element-278">
              "I'm a mom of two and run my own e-commerce store. I thought I
              just needed more coffee. This protocol gave me back my brain. My
              afternoon fog vanished by Day 2."
            </p>
            <div className="mb-4 rounded-lg border border-neon/20 bg-neon/10 px-3.5 py-2.5 font-mono text-[13px] font-bold text-neon" data-id="element-279">
              ⚡ Result: No more 3PM crashes since Week 1
            </div>
            <div className="flex items-center gap-3" data-id="element-280">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-neon/20 bg-card text-[22px]" data-id="element-281">
                👩
              </div>
              <div data-id="element-282">
                <div className="text-[14px] font-bold text-offwhite" data-id="element-283">
                  Sarah L.
                </div>
                <div className="font-mono text-[12px] text-coolgray" data-id="element-284">
                  Entrepreneur — Denver, CO
                </div>
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl border border-neon/10 bg-slate p-7 transition-all duration-300 hover:-translate-y-1 hover:border-neon/30" data-id="element-285">
            <div className="mb-2 text-[13px] text-gold" data-id="element-286">★★★★★</div>
            <div className="mb-3 font-serif text-[48px] leading-[0.8] text-neon/30" data-id="element-287">
              "
            </div>
            <p className="mb-5 text-[15px] italic leading-[1.7] text-offwhite" data-id="element-288">
              "The morning light protocol sounds almost too simple. But after 3
              days I was waking up feeling actually rested for the first time in
              2 years. It's wild."
            </p>
            <div className="mb-4 rounded-lg border border-neon/20 bg-neon/10 px-3.5 py-2.5 font-mono text-[13px] font-bold text-neon" data-id="element-289">
              ⚡ Result: Deep sleep quality up 40%
            </div>
            <div className="flex items-center gap-3" data-id="element-290">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-neon/20 bg-card text-[22px]" data-id="element-291">
                👨🏽
              </div>
              <div data-id="element-292">
                <div className="text-[14px] font-bold text-offwhite" data-id="element-293">
                  Carlos M.
                </div>
                <div className="font-mono text-[12px] text-coolgray" data-id="element-294">
                  Financial Analyst — Miami, FL
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Big Featured Testimonial */}
        <div className="grid grid-cols-1 items-start gap-[30px] rounded-2xl border-2 border-neon/20 bg-slate p-10 md:grid-cols-[auto_1fr]" data-id="element-295">
          <div className="mx-auto flex h-20 w-20 shrink-0 items-center justify-center rounded-full border-[3px] border-neon bg-card text-[40px] md:mx-0" data-id="element-296">
            👩🏻
          </div>
          <div className="text-center md:text-left" data-id="element-297">
            <div className="mb-3 text-[18px] text-gold" data-id="element-298">★★★★★</div>
            <p className="mb-4 text-[18px] italic leading-[1.8] text-offwhite" data-id="element-299">
              "I've spent thousands of dollars on Huberman supplements, cold
              plunge tubs, and red light panels. Turns out I was missing the
              basics. This $6.97 guide did more for my focus in 15 days than
              $3,000 in biohacking equipment. I'm embarrassed it took me this
              long to find it."
            </p>
            <div className="inline-block rounded-lg border border-neon/20 bg-neon/10 px-3.5 py-2.5 font-mono text-[13px] font-bold text-neon" data-id="element-300">
              ⚡ Result: Eliminated $300/month supplement spend. Focus at
              all-time high.
            </div>
            <div className="mt-4 flex items-center justify-center gap-3 md:justify-start" data-id="element-301">
              <div className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full border-2 border-neon/20 bg-card text-[28px]" data-id="element-302">
                👩🏻
              </div>
              <div className="text-left" data-id="element-303">
                <div className="text-[16px] font-bold text-offwhite" data-id="element-304">
                  Dr. Amanda K.
                </div>
                <div className="font-mono text-[12px] text-coolgray" data-id="element-305">
                  MD, Internal Medicine — San Francisco, CA
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}